import { useState, useCallback, useEffect, useContext } from "react";
import { r as readValue, w as writeValue } from "./safeStorageUtils-cA7Apjm4.js";
const STORAGE_CHANGE_CUSTOM_EVENT = "storage-change";
function useBrowserStorage({
  key,
  value,
  storage = globalThis.localStorage
}) {
  const [storageValue, setStorageValue] = useState(
    () => readValue({ key, defaultValue: value, storage })
  );
  const setValue = useCallback(
    (newValue) => {
      try {
        writeValue({ key, value: newValue, storage });
        setStorageValue(newValue);
        globalThis.dispatchEvent(new Event(STORAGE_CHANGE_CUSTOM_EVENT));
      } catch (err) {
        console.warn("Failed to write to storage - value", err);
      }
    },
    [key, storage]
  );
  const handleStorageChange = useCallback(
    () => setStorageValue(readValue({ key, defaultValue: value, storage })),
    [key, storage, value]
  );
  useEffect(() => {
    globalThis.addEventListener(STORAGE_CHANGE_CUSTOM_EVENT, handleStorageChange);
    return () => {
      globalThis.removeEventListener(STORAGE_CHANGE_CUSTOM_EVENT, handleStorageChange);
    };
  }, [handleStorageChange]);
  const removeItem = useCallback(() => {
    try {
      storage == null ? void 0 : storage.removeItem(key);
      globalThis.dispatchEvent(new Event(STORAGE_CHANGE_CUSTOM_EVENT));
    } catch (err) {
      console.error("Failed to remove to storage - value", err);
    }
  }, [key, storage]);
  return { storageValue, setValue, removeItem };
}
function useSafeContext(contextObject) {
  const context = useContext(contextObject);
  if (!contextObject.displayName) {
    throw new Error("Context.displayName is not set, it must be set for useSafeContext");
  }
  if (context === void 0) {
    const contextName = contextObject.displayName.split("Context")[0];
    throw new TypeError(`use${contextName} must be used within a ${contextName}Provider`);
  }
  return context;
}
function useForm(options) {
  const [values, setData] = useState((options == null ? void 0 : options.initialValues) || {});
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({
      ...values,
      [name]: value
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (options == null ? void 0 : options.onSubmit) {
      void Promise.resolve(options.onSubmit(values));
    }
  };
  const setValue = (key, value) => {
    setData({
      ...values,
      [key]: value
    });
  };
  return {
    values,
    handleChange,
    handleSubmit,
    setValue
  };
}
export {
  useBrowserStorage,
  useForm,
  useSafeContext
};
//# sourceMappingURL=react.js.map
